import styled from 'styled-components';

export const BookRegistrationContainer = styled.div`
  width: 100%;
  border-radius: 10px;
  background-color: #f7f7f7;

  padding-bottom: 20px;

  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  gap: 20px;
`;

export const InputCloseBlock = styled.div`
  padding: 20px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
`;

export const CloseCollapseTag = styled.div`
  user-select: none;
  width: auto;
  display: flex;
  gap: 10px;
  flex-direction: row;
`;

export const BlueBookForm = styled.div`
  width: 100%;
  background-color: #eef2f8;
  padding: 20px;
`;

export const NewBookText = styled.div`
  font-size: 20px;
  font-weight: 500;
  color: #698cb5;
  padding: 10px 20px;
  margin-bottom: -10px;

  display: flex;
  justify-content: space-between;
  flex-direction: row;
`;
